<template>
  <div class>
    <v-row class="header-state-view">
      <v-col cols="12" class="py-0">
        <v-card-title class="py-3 headline white--text" primary-title>
          Data Information - {{ dataInfo.senderId }} / {{ dataInfo.recipientId }} /
          {{ dataInfo.messageName }} -
          {{ dataInfo.processId }}
        </v-card-title>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-card class="pa-6 monitor-datainfo-layout-container">
          <v-card-text class="mb-2 pa-0">
            <v-row class="r-popup-content">
              <v-col cols="12" class="grid-pd">
                <v-row class="mt-0 status-section-mb">
                  <v-col cols="12" sm="2" class="pr-0 pt-0 pb-0">
                    Sender :
                    <span>{{ dataInfo.senderId }}</span>
                  </v-col>
                  <v-col cols="12" sm="2" class="pr-0 pt-0 pb-0">
                    Receiver :
                    <span>{{ dataInfo.recipientId }}</span>
                  </v-col>
                  <v-col cols="12" sm="2" class="pr-0 pt-0 pb-0">
                    Message :
                    <span>{{ dataInfo.messageName }}</span>
                  </v-col>
                  <v-col cols="12" sm="2" class="pr-0 pt-0 pb-0">
                    Partner :
                    <span>{{ dataInfo.partnerName }}</span>
                  </v-col>
                  <v-col cols="12" sm="2" class="pr-0 pt-0 pb-0">
                    Direction :
                    <span>{{ directionText(dataInfo.direction) }}</span>
                  </v-col>
                  <v-col cols="12" sm="2" class="pr-0 pt-0 pb-0"></v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="r-popup-content">
              <v-col cols="12" sm="6" class="grid-pd">
                <v-row class="v-grid-title">
                  <v-col class="pa-2">
                    <span>Process Message</span>
                  </v-col>
                </v-row>
                <v-row class="v-grid-content">
                  <v-col class="pa-0">
                    <v-row class="no-gutters">
                      <div :class="['CodeMirror', isJsonFile ? 'json-color-format' : '']">
                        <EDIViewer v-model="inputFileContents" :options="cmOption_in"></EDIViewer>
                        <input type="hidden" id="inputFileContentsHdn" />
                        <v-overlay :absolute="absolute" :value="overlayIn">
                          <v-btn color="success" @click="overlayIn = false">{{ this.inMsg }}</v-btn>
                        </v-overlay>
                      </div>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" sm="6" class="grid-pd">
                <v-row class="v-grid-title">
                  <v-col class="pa-2">
                    <span>User Data</span>
                  </v-col>
                </v-row>
                <v-row class="v-grid-content">
                  <v-col class="pa-0">
                    <v-row class="no-gutters">
                      <div class="CodeMirror">
                        <BIZViewer v-model="outputFileContents" :options="cmOption_out"></BIZViewer>
                        <input type="hidden" id="outputFileContentsHdn" />
                        <v-overlay :absolute="absolute" :value="overlayOut">
                          <v-btn color="success" @click="overlayOut = false">{{
                            this.outMsg
                          }}</v-btn>
                        </v-overlay>
                      </div>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-row class="ml-0 mr-0 merge-button-group">
            <v-col class="mt-1 button-col action-col pa-0" lg="6">
              <div class="btn-form-control text-right">
                <v-btn
                  v-if="this.readonlyModeStatus && $auth.manage"
                  class="btn btn-active mr-2"
                  @click="
                    editMode();
                    overlayIn = !overlayIn;
                  "
                >
                  {{ $t('btn.common.editmode') }}
                </v-btn>
                <v-btn
                  v-if="!this.readonlyModeStatus && $auth.manage"
                  class="btn btn-active mr-2"
                  @click="
                    viewMode();
                    overlayIn = !overlayIn;
                  "
                >
                  {{ $t('btn.common.viewmode') }}
                </v-btn>
                <v-btn
                  v-if="$auth.manage"
                  class="btn btn-active mr-2"
                  @click="
                    reTranslation(inputFileContents);
                    overlayIn = !overlayIn;
                  "
                >
                  {{ $t('btn.common.retrslt') }}
                </v-btn>
              </div>
            </v-col>
            <v-col class="mt-1 button-col action-col pa-0" lg="6">
              <div class="btn-form-control text-right">
                <v-btn class="btn btn-delete" @click="closeWindow('btn-close')">
                  {{ $t('btn.common.close') }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BIZViewer from '@/vue-dlb/components/viewers/codemirror.vue';
import EDIViewer from '@/vue-dlb/components/viewers/codemirror.vue';
import { mapState } from 'vuex';

// language
import 'codemirror/mode/swift/swift.js';

// theme css
import 'codemirror/theme/rubyblue.css';

// active-line.js
import 'codemirror/addon/selection/active-line.js';

// styleSelectedText
import 'codemirror/addon/selection/mark-selection.js';
import 'codemirror/addon/search/searchcursor.js';

// highlightSelectionMatches
import 'codemirror/addon/scroll/annotatescrollbar.js';
import 'codemirror/addon/search/matchesonscrollbar.js';
import 'codemirror/addon/search/searchcursor.js';
import 'codemirror/addon/search/match-highlighter.js';

// keyMap
import 'codemirror/mode/clike/clike.js';
import 'codemirror/addon/edit/matchbrackets.js';
import 'codemirror/addon/comment/comment.js';
import 'codemirror/addon/dialog/dialog.js';
import 'codemirror/addon/dialog/dialog.css';
import 'codemirror/addon/search/searchcursor.js';
import 'codemirror/addon/search/search.js';
import 'codemirror/keymap/sublime.js';

// foldGutter
import 'codemirror/addon/fold/foldgutter.css';
import 'codemirror/addon/fold/brace-fold.js';
import 'codemirror/addon/fold/comment-fold.js';
import 'codemirror/addon/fold/foldcode.js';
import 'codemirror/addon/fold/foldgutter.js';
import 'codemirror/addon/fold/indent-fold.js';
import 'codemirror/addon/fold/markdown-fold.js';
import 'codemirror/addon/fold/xml-fold.js';

export default {
  components: {
    EDIViewer,
    BIZViewer,
  },
  name: 'monitoring-file-view-window',

  data: () => ({
    absolute: true,
    overlayIn: false,
    overlayOut: false,
    inputFileContents: '',
    outputFileContents: '',
    inMsg: '',
    outMsg: '',
    dataInfo: {},
    readonlyModeStatus: true,
    inputFileContentCheck: '',
    inputFileContentsHdn: '',
    isJsonFile: false,
  }),

  computed: {
    ...mapState('analysis', {
      fileViewWindowParam: 'fileViewWindowParam',
    }),
    cmOption_in() {
      if (this.$vuetify.theme.isDark == true) {
        return {
          tabSize: 4,
          lineWrapping: true,
          foldGutter: true,
          lineNumbers: true,
          line: true,
          readOnly: this.readonlyModeStatus,
          keyMap: 'sublime',
          mode: 'text/x-swift',
          theme: 'rubyblue',
          extraKeys: {
            F11(cm) {
              cm.setOption('fullScreen', !cm.getOption('fullScreen'));
            },
            Esc(cm) {
              if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false);
            },
          },
        };
      }
      return {
        tabSize: 4,
        lineWrapping: true,
        foldGutter: true,
        lineNumbers: true,
        line: true,
        readOnly: this.readonlyModeStatus,
        keyMap: 'sublime',
        mode: 'text/x-swift',
        theme: 'default',
        extraKeys: {
          F11(cm) {
            cm.setOption('fullScreen', !cm.getOption('fullScreen'));
          },
          Esc(cm) {
            if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false);
          },
        },
      };
    },
    cmOption_out() {
      if (this.$vuetify.theme.isDark == true) {
        return {
          tabSize: 4,
          lineWrapping: true,
          foldGutter: true,
          lineNumbers: true,
          line: true,
          readOnly: true,
          keyMap: 'sublime',
          mode: 'text/x-swift',
          theme: 'rubyblue',
          extraKeys: {
            F11(cm) {
              cm.setOption('fullScreen', !cm.getOption('fullScreen'));
            },
            Esc(cm) {
              if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false);
            },
          },
        };
      }
      return {
        tabSize: 4,
        lineWrapping: true,
        foldGutter: true,
        lineNumbers: true,
        line: true,
        readOnly: true,
        keyMap: 'sublime',
        mode: 'text/x-swift',
        theme: 'default',
        extraKeys: {
          F11(cm) {
            cm.setOption('fullScreen', !cm.getOption('fullScreen'));
          },
          Esc(cm) {
            if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false);
          },
        },
      };
    },
  },

  methods: {
    isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    initialize() {
      let params = {};
      params = this.dataInfo;

      this.$store.dispatch('getinputFileContens', params.fileLink).then(() => {
        if (this.$store.getters.inputFileContents != null) {
          let rslt = this.$store.getters.inputFileContents;
          if (this.isJson(rslt)) {
            this.inputFileContents = JSON.stringify(JSON.parse(rslt), null, 4);
            this.isJsonFile = true;
          } else {
            this.inputFileContents = this.convertFollowMessage(rslt);
            this.isJsonFile = false;
          }

          this.outputFileContents = params.userData
            .split(`{`)
            .join('{\n')
            .split(`,`)
            .join(',\n')
            .split(`}`)
            .join('\n}')
            .split(`"`)
            .join('');
        }
        this.inputFileContentCheck = this.inputFileContents;
        this.inputFileContentsHdn = this.inputFileContents;
      });
    },
    convertFollowMessage(input) {
      let replace = '';
      if (input.match(/^ISA\*/g)) {
        replace = input.replace(/~/g, '~\n');
      } else if (input.match(/^UNB\+/g) || input.match(/^\s*(?:UNA.{5}')?/g)) {
        replace = input.replace(/'/g, "'\n");
      } else {
        replace = input.replace(/'/g, '\n');
      }
      return replace;
    },
    closeWindow(type) {
      const message = {
        message: type,
      };
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(message, '*');
      }

      setTimeout(() => {
        window.close();
      }, 50);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    directionText(direction) {
      if (direction === 'I') return 'Inbound';
      else if (direction === 'O') return 'Outbound';
    },
    editMode() {
      this.readonlyModeStatus = false;
      this.inMsg = 'Editable';
    },
    viewMode() {
      this.readonlyModeStatus = true;
      this.inMsg = 'Non-editable';
      this.inputFileContentsHdn = this.inputFileContents;
    },
    reTranslation(content) {
      let data = this.dataInfo.dataTrans;
      data[0].payload.messageSequence = this.dataInfo.record.messageSequence;
      data[0].payload.userData.messageSequence = this.dataInfo.record.messageSequence;
      data[0].payload.userData.isServer = 'TEST';
      if (
        this.inputFileContentCheck.localeCompare(this.inputFileContents) !== 0 &&
        !this.readonlyModeStatus
      ) {
        data[0].payload.fileContent = this.inputFileContents;
        this.checkEdit = false;
      }
      this.$store.dispatch('execReTranslation', { data: data }).then(() => {
        this.inMsg = 'ReTranslation is complete.';
      });
    },
  },
  created() {
    if (this.$route.query.theme === 'Dark') {
      this.$vuetify.theme.dark = true;
    } else {
      this.$vuetify.theme.dark = false;
    }

    let param = this.fileViewWindowParam[this.$route.params.id];
    this.dataInfo = param['options'].dataValue;
    this.$auth = param['options'].auth;
    this.initialize();
  },
};
</script>

<style>
.monitor-datainfo-layout-dialog {
  width: 1000px !important;
}
.monitor-datainfo-layout-dialog .v-card__text {
  font-size: 13px;
  line-height: 19px;
}
.monitor-datainfo-layout-dialog .v.grid-content {
  height: 528px;
  margin-bottom: 10px !important;
}
.monitor-datainfo-layout-container .CodeMirror-gutters {
  left: 0 !important;
}
.monitor-datainfo-layout-container .CodeMirror-gutter-wrapper {
  left: -36px !important;
}
.monitor-datainfo-layout-container .v-grid-title .v-input {
  height: auto !important;
}
.monitor-datainfo-layout-container .v-grid-title .v-input .v-input__slot {
  height: 40px !important;
}
.theme--light .monitor-datainfo-layout-container .v-grid-title .v-input {
  background: #ffffff;
}
.theme--dark .monitor-datainfo-layout-container {
  background-color: #2a2c35 !important;
}
.monitor-datainfo-layout-container .v-grid-content {
  height: 498px;
  background-color: #2a2c35;
  border: 3px solid #4e686f !important;
  padding: 0px;
}
.theme--dark .monitor-datainfo-layout-container .v-grid-title {
  height: 40px;
  width: 35%;
  background-color: #121212;
  border: 3px solid #4e686f !important;
  margin-top: 12.5px !important;
  margin-bottom: -8px !important;
}
.theme--light .monitor-datainfo-layout-container .v-grid-title {
  height: 40px;
  width: 35%;
  background-color: #ffffff;
  border: 3px solid #4e686f !important;
  margin-top: 30px !important;
  margin-bottom: -8px !important;
}
.theme--dark .monitor-datainfo-layout-container .v-grid-title .v-input {
  background: #2a2c35;
  border: none;
}
.theme--light span {
  font-family: Open Sans;
  font-style: normal;
}
.theme--dark span {
  font-family: Open Sans;
  font-style: normal;
  color: #ffffff;
}
.v-select {
  padding: 0 !important;
}
</style>
